import type { FC } from 'react';
import { LOGO_SRC } from '../copy';

// Centred Unimo wordmark. Height matches source: 96px desktop, 56px mobile.
// The wordmark is shared across all industry variants.
export const OnePagerLogo: FC = () => (
  <div className="mb-8 flex justify-center md:mb-16">
    <img src={LOGO_SRC} alt="Unimo" className="block h-14 w-auto md:h-24" />
  </div>
);
